import React, { useMemo } from 'react';
import { Image } from 'expo-image';
import { Image as RNImage } from 'react-native';
import { useCommunity } from '~/hooks/useCommunity';
import { getSocialTagIcon } from '~/constants/socialTagIcons';
import { type CommunityCode } from '~/constants/communities';

interface SocialTagIconProps {
  tag: string;
  size?: number;
}

export function SocialTagIcon({ tag, size = 18 }: SocialTagIconProps) {
  const community = useCommunity();
  const communityCode = community?.code as CommunityCode | undefined;
  const icon = communityCode ? getSocialTagIcon(communityCode, tag) : undefined;

  const width = useMemo(() => {
    if (!icon) return size;
    if (typeof icon === 'number') {
      const asset = RNImage.resolveAssetSource(icon);
      return asset ? size * (asset.width / asset.height) : size;
    }
    if (typeof icon === 'object' && 'width' in icon && 'height' in icon) {
      const { width: w, height: h } = icon as { width: number; height: number };
      return h > 0 ? size * (w / h) : size;
    }
    return size;
  }, [icon, size]);

  if (!icon) return null;

  return (
    <Image
      source={icon}
      style={{ height: size, width, borderRadius: 3 }}
      contentFit="contain"
      cachePolicy="memory"
    />
  );
}
